import type {
  MapCoordinateV1,
  PropertyMapConfigurationV1,
} from "@impetusos/contracts"

import { createPropertyMapPresentation } from "../capabilities/property-mapping/index.js"

const presentation = createPropertyMapPresentation()

export const propertyMapImageUrl = (
  configuration: PropertyMapConfigurationV1,
  center: MapCoordinateV1,
  zoom: number,
): string => presentation.staticImageUrl(configuration, center, zoom)
